import type { ReactNode } from 'react';

export const symbol_stock_media: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-360q-24 0-42-18t-18-42v-400q0-24 18-42t42-18h400q24 0 42 18t18 42v400q0 24-18 42t-42 18H140Zm0-60h400v-400H140v400Zm181-80-51-63q-2.31-3-6.15-3-3.85 0-5.85 3l-51 71q-3 4-.75 8t6.75 4h253q4.5 0 6.75-4t-.75-8l-73-97q-2.31-3-6.15-3-3.85 0-5.85 3l-66 89Zm291 387.88q-32-32.12-32-78T612.08-268q32.09-32 77.92-32 14.3 0 26.65 3 12.35 3 23.35 9v-182q0-12.75 8.63-21.38Q757.25-500 770-500h80q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5h-50v250q0 45.83-32.12 77.92Q735.76-80 689.88-80T612-112.12ZM140-420v-400 400Z"
		/>
	</svg>
);
